// extracted by mini-css-extract-plugin
export default {"manual":"manual_manual__jOUB+","menuItem":"manual_menuItem__Wa009","dropdownMenu":"manual_dropdownMenu__iPCOb","dropdownItem":"manual_dropdownItem__1uymk"};